module.exports = __webpack_public_path__ + "static/media/branding-watermark.18376654.png";